import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { TaskTrackerSettings } from '../types'
import { parseTaskTrackerData } from './ConfigData'

interface TaskTrackerComponent
  extends CustomComponentEnhanced<TaskTrackerSettings> {}

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch =
    useUpdateCustomComponent<TaskTrackerSettings>(componentID)
  const currentSemanticSearch =
    useGetCustomComponent<TaskTrackerSettings>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseTaskTrackerData
  )
  const parseData = (
    data?: TaskTrackerComponent | null
  ): TaskTrackerComponent => {
    if (!data) return {} as TaskTrackerComponent
    return pick(
      ['name', 'description', 'settings', 'type'],
      data
    ) as TaskTrackerComponent
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data as unknown as TaskTrackerComponent)
    if (!restoredData) return
    await updateSemanticSearch.mutateAsync(restoredData)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
